/* eslint-env browser */

'use strict';

module.exports = (currentOption, allTraitsSelected) => {
  //hide discount if is equal to price
  const value =
    currentOption.value.formattedAmount !== currentOption.price.formattedAmount
      ? currentOption.value.formattedAmount
      : null;

  const {
    percent,
    savings,
    buyUrl,
    uuid,
    hideOriginalPriceAndDiscount,
    showDifferenceMessage,
    sale,
    isSoldOut,
    externalUrl,
  } = currentOption;

  let url = buyUrl;
  if (externalUrl && externalUrl.length) {
    url = externalUrl;
  } else if (
    window.payload.cartStatus &&
    !window.payload.shouldDisableGoodsCart
  ) {
    url = '#';
  }

  return {
    value,
    percent,
    savings,
    price: currentOption.price.formattedAmount,
    lengthClass: currentOption.price.lengthClass,
    buyUrl: url,
    uuid,
    variationsSelected: allTraitsSelected,
    hideOriginalPriceAndDiscount,
    showDifferenceMessage,
    soldMessage: currentOption.soldMessage && currentOption.soldMessage.title,
    sale,
    amount: currentOption.price.amount,
    url,
    isSoldOut,
  };
};
